// ONE-CLICK [temporary — see docs/refactoring/ONE-CLICK-UPGRADE-FEATURE.md]
//
// Dedicated factory-selector for the one-click push state. Kept out of
// system.selectors.ts (shared by many blocks) so it drops with the folder.

import { createSelector } from '@ngrx/store';

import { selectSystemState } from '../../../store/selectors/system.selectors';
import { OneClickPushState } from './one-click.utils';

/**
 * Read the push state (arm version, updating flag, fota flag, upd_global
 * progress) for a specific inverter from the certified plant in the store.
 * Reads from `logger.inverter[]` (SolarmanInverterType). Returns null when not found.
 */
export const selectOneClickPushState = (inverterSn: string) =>
  createSelector(selectSystemState, (state): OneClickPushState | null => {
    const selected = state.selectedSystemUid;
    if (!selected) {
      return null;
    }
    const system = state.systemList[selected];
    const loggers = system?.aws?.loggers ?? [];
    const target = inverterSn.toUpperCase();

    for (const logger of loggers) {
      const match = logger.inverter?.find((d) => d.sn?.toUpperCase() === target);
      if (!match) {
        continue;
      }
      return {
        arm: match.arm ?? null,
        updating: !!match.updating,
        fotaStatus: match.fota_status ?? null,
        updGlobal: match.upd_global
          ? {
              status: match.upd_global.status,
              progress: match.upd_global.progress,
              createdAt: match.upd_global.createdAt,
            }
          : null,
      };
    }
    return null;
  });
